import render from './render'

export default {
  name: 'AfterTitle',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
